$(document).on('change', '[data-get-cities]', function () {

    const csrf = $(this).data('csrf'),
        country_id = $(this).val(),
        el_target = $($(this).data('target'));

    if (!country_id){
        if (el_target.data('target')){
            $(el_target.data('target')).children(':not(:first-child)').remove();
        }

        return el_target.children(':not(:first-child)').remove();

    }

    $.ajax({
        type: 'GET',
        url: App.prototype.apiAddress + 'countries/' + country_id + '/cities?_token=' + csrf,
        dataType: "json",
        success: function( response ) {
            el_target.children(':not(:first-child)').remove();

            if (el_target.data('target')){
                $(el_target.data('target')).children(':not(:first-child)').remove();
            }

            if (response && response.length){

                for (const responseElement of response) {

                    el_target.append('<option value="' + responseElement.id + '">' + responseElement.name + '</option>');

                }

            }
        }
    });
});
